module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[80]323.1773468.woff2";